import React from "react";
import topRightPic from "../../../Assets/Image/png/top-right.png";
import topLeftPic from "../../../Assets/Image/png/top-left.png";
import bottomRightPic from "../../../Assets/Image/png/bottom-right.png";

function DashCard({ bottomRight, topLeft, topRight, topRightsmall, ...props }) {
  return (
    <div
      className={`${props.className} rounded-16 bg-white-dark relative overflow-hidden`}
    >
      {topRight && (
        // <img src={topRightPic} className="absolute right-0 top-0" />
        <div className=" absolute top-0 right-0 border-[1rem] border-solid border-[#9c5fa436] opacity-[0.3] rounded-[50%] w-[10.5rem] h-[10.5rem]"></div>
      )}
      {topRight && (
        // <img src={topRightPic} className="absolute right-0 top-0" />
        <div className=" absolute top-[-3.6rem] right-[-3.5rem] border-[1rem] border-solid border-[#9c5fa436] opacity-[0.3] rounded-[50%] w-[17.6rem] h-[17.6rem]"></div>
      )}
      {topLeft && (
        //    <img src={topLeftPic} className="absolute left-0 top-0" />
        <div className=" absolute top-[-2rem] left-[-2rem] border-[1rem] border-solid border-[#9c5fa436] opacity-[0.3] rounded-[50%] w-[10.5rem] h-[10.5rem]">
          {" "}
        </div>
      )}
      {topLeft && (
        //    <img src={topLeftPic} className="absolute left-0 top-0" />
        <div className=" absolute top-[-4.5rem] left-[-4.5rem] border-[1rem] border-solid border-[#9c5fa436] opacity-[0.3] rounded-[50%] w-[17.6rem] h-[17.6rem]">
          {" "}
        </div>
      )}
      {topRightsmall && (
        //    <img src={topLeftPic} className="absolute left-0 top-0" />
        <div className=" absolute top-[-2rem] right-[-2rem] border-[1rem] border-solid border-[#9c5fa436] opacity-[0.3] rounded-[50%] w-[10.5rem] h-[10.5rem]">
          {" "}
        </div>
      )}
      {topRightsmall && (
        //    <img src={topLeftPic} className="absolute left-0 top-0" />
        <div className=" absolute top-[-4.5rem] right-[-4.5rem] border-[1rem] border-solid border-[#9c5fa436] opacity-[0.3] rounded-[50%] w-[17.6rem] h-[17.6rem]">
          {" "}
        </div>
      )}
      {bottomRight && (
        <img src={bottomRightPic} className="absolute right-0 bottom-0" />
      )}
      {props.children}
    </div>
  );
}

export default DashCard;
